import useMedia from '@hooks/use-media';
import useOnce from '@hooks/use-once';
import { parseAndCachePrefilledCardData, parseAndCacheReferralTrackingData } from '@modules/referral-helpers';
import { getFeatureVariant } from '@modules/server-utils/feature-flags';
import { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';

import { useRouter } from 'next/router';

const SignupRedirect: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({ variant }) => {
  const { query, replace, isReady } = useRouter();
  const screenSizeCategory = useMedia<'small' | 'large'>([`(min-width: ${701}px)`], ['large'], 'small');

  useOnce(
    (preventSecondRun) => {
      if (!isReady) {
        return;
      }

      const queryParams = new URLSearchParams(query as Record<string, string>).toString();

      console.log({ variant });

      if (query._dl === 'shareCard') {
        parseAndCachePrefilledCardData(query);
        parseAndCacheReferralTrackingData(query);
      }
      if (screenSizeCategory === 'large') {
        if (variant === 'treatment') {
          replace(`/onboarding/individual/create-card?${queryParams}`);
          return;
        }
        replace(`/onboarding/customize-card?${queryParams}`);
      } else {
        replace(`/onboarding/personal-details?${queryParams}`);
      }
      preventSecondRun();
    },
    [query, isReady, variant]
  );

  return null;
};

export default SignupRedirect;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const variant = await getFeatureVariant('individual-onboarding-wizard-iteration-3', 'control', {
    req: context.req,
  });
  return {
    props: {
      variant,
    },
  };
};
